(() => {
  class CarouselController extends Stimulus.Controller {
    static targets = ["scroller", "item", "arrowLeft", "arrowRight", "thumbnails"]
    
    connect() {
      // Initialize event listeners
      this.boundCheckArrows = () => this.checkArrows()
      this.scrollerTarget.addEventListener('scroll', this.boundCheckArrows)
      window.addEventListener('resize', this.boundCheckArrows)
      
      // Initial check
      this.checkArrows()
      
      // Initialize intersection observer for items if we have thumbnails
      if (this.hasThumbnailsTarget) {
        this.setupIntersectionObserver()
      }
    }

    disconnect() {
      // Cleanup event listeners
      this.scrollerTarget.removeEventListener('scroll', this.boundCheckArrows)
      window.removeEventListener('resize', this.boundCheckArrows)
      
      // Cleanup observer
      if (this.observer) {
        this.observer.disconnect()
      }
    }

    scrollLeft() {
      const containerWidth = this.scrollerTarget.clientWidth;
      const scrollAmount = Math.max(containerWidth * 0.8, this.itemTargets[0].offsetWidth);
      
      this.scrollerTarget.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
      setTimeout(() => this.checkArrows(), 500);
    }

    scrollRight() {
      const containerWidth = this.scrollerTarget.clientWidth;
      const scrollAmount = Math.max(containerWidth * 0.8, this.itemTargets[0].offsetWidth);
      
      this.scrollerTarget.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
      setTimeout(() => this.checkArrows(), 500);
    }

    checkArrows() {
      const scroller = this.scrollerTarget
      const currentScroll = Math.round(scroller.scrollLeft)
      const maxScroll = scroller.scrollWidth - scroller.clientWidth
      const threshold = 5

      const isAtStart = currentScroll <= threshold
      const isAtEnd = Math.abs(maxScroll - currentScroll) <= threshold

      this.arrowLeftTarget.classList.toggle('disabled', isAtStart)
      this.arrowLeftTarget.setAttribute('aria-disabled', isAtStart)
      this.arrowLeftTarget.tabIndex = isAtStart ? -1 : 0

      this.arrowRightTarget.classList.toggle('disabled', isAtEnd)
      this.arrowRightTarget.setAttribute('aria-disabled', isAtEnd)
      this.arrowRightTarget.tabIndex = isAtEnd ? -1 : 0
    }
    
    // New methods for thumbnail functionality
    setupIntersectionObserver() {
      const options = {
        root: this.scrollerTarget,
        rootMargin: '0px',
        threshold: 0.6 // Element is considered visible when 60% visible
      }
      
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = this.itemTargets.indexOf(entry.target)
            this.updateActiveThumbnail(index)
          }
        })
      }, options)
      
      this.itemTargets.forEach(item => {
        this.observer.observe(item)
      })
    }
    
    updateActiveThumbnail(index) {
      if (!this.hasThumbnailsTarget) return
      
      // Get all thumbnail links
      const thumbnails = this.thumbnailsTarget.querySelectorAll('a')
      
      // Remove active class from all thumbnails
      thumbnails.forEach(thumb => thumb.classList.remove('active'))
      
      // Add active class to current thumbnail
      if (thumbnails[index]) {
        thumbnails[index].classList.add('active')
      }
    }
    
    scrollToThumbnail(event) {
      const index = parseInt(event.currentTarget.dataset.carouselIndex)
      if (isNaN(index)) return
      
      // Scroll to the selected item
      this.itemTargets[index].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      })
      
      // Update the active thumbnail
      this.updateActiveThumbnail(index)
      
      // Prevent default click behavior
      event.preventDefault()
    }
    
    // Handle external events (like when variant changes)
    scrollToImage(event) {
      if (event.detail && event.detail.mediaId) {
        const mediaId = event.detail.mediaId
        const mediaElement = document.getElementById(`media-${mediaId}`)
        
        if (mediaElement) {
          // Find the index of the media element
          const index = this.itemTargets.indexOf(mediaElement)
          
          if (index !== -1) {
            // Scroll to the media
            mediaElement.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start'
            })
            
            // Update the active thumbnail
            this.updateActiveThumbnail(index)
          }
        }
      }
    }
  }

  // Register controller when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    if (window.StimulusApp) {
      window.StimulusApp.register("carousel", CarouselController)
    } else {
      console.error('StimulusApp not found')
    }
  })
})()